module.exports = __webpack_public_path__ + "static/img/neutral.729532c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/neutral.gif
// module id = SnIB
// module chunks = 1